import React, { useContext } from 'react';

import PropTypes from 'prop-types';

import I18nContext from '../../contexts/I18nContext';

interface HelloWorldUIProps {
  name?: string | null;
  withEmoji?: boolean;
}

function HelloWorldUI({ name, withEmoji }: HelloWorldUIProps): JSX.Element {
  const { Trans } = useContext(I18nContext);
  return (
    <div className="au-text-[22px]">
      {name ? (
        <Trans i18nKey="helloLoggedIn" values={{ name }} />
      ) : (
        <Trans i18nKey="helloLoggedOut" />
      )}
      {withEmoji ? <span> 👋</span> : null}
    </div>
  );
}

HelloWorldUI.defaultProps = {
  name: null,
  withEmoji: false,
};

HelloWorldUI.propTypes = {
  name: PropTypes.string,
  withEmoji: PropTypes.bool,
};

export default HelloWorldUI;
